<template>
  <collapse-transition>
    <div v-show="isOpen" class="header-mobile-expanded__wrapper">
      <div :style="dynamicStyle" class="header-mobile-expanded__container">
        <a-header-navigation
          class="header-mobile-expanded__navigation"
          @item-click="onItemClick"
        />

        <a-header-vote-button
          v-if="isVotingButtonVisible"
          class="header-mobile-menu__vote-btn"
          @click="onItemClick"
        />
      </div>
    </div>
  </collapse-transition>
</template>

<script>
import { PROP_TYPES, propValidator } from '@fmpedia/validators'
import AHeaderNavigation from '@/components/_layout/AHeader/AHeaderNavigation/index.vue'
import { mapGetters } from 'vuex'
import AHeaderVoteButton from 'sections/_voting/shared/AHeaderVoteButton'
import { IS_VOTING_CLOSED } from 'enums/main-route'
import { ROUTE_NAME } from 'enums/routes'

export default {
  name: 'AHeaderMobileMenuExpanded',
  components: { AHeaderNavigation, AHeaderVoteButton },
  consts: {
    IS_VOTING_CLOSED
  },
  props: {
    isOpen: propValidator([PROP_TYPES.BOOLEAN])
  },
  model: {
    prop: 'isOpen'
  },
  computed: {
    ...mapGetters({
      mobileBottomPadding: 'mobileBottomPadding'
    }),
    dynamicStyle() {
      return {
        paddingBottom: `${this.mobileBottomPadding}px`
      }
    },
    isVotingButtonVisible() {
      return this.$route.name !== ROUTE_NAME.THANK_YOU && !IS_VOTING_CLOSED
    }
  },
  methods: {
    onItemClick() {
      this.$emit('input', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.header-mobile-expanded__wrapper {
  height: calc(100vh - #{$mobile-header-height});
  width: 100%;
  position: fixed;
  background: $c--black;
  z-index: $z-index-header;
  top: $mobile-header-height;
  left: 0;
  overflow: auto;

  .header-mobile-expanded__container {
    display: flex;
    align-items: center;
    flex-direction: column;
  }

  .header-mobile-menu__vote-btn {
    width: 100%;
    max-width: 288px;
    margin-top: 13px;
  }

  .header-mobile-expanded__navigation {
    flex-grow: 0;
    width: 100%;

    $padding: (
      $above-desktop-xl: 32px $padding-x-desktop-sm 0,
      $mobile: 32px $padding-x-mobile 0
    );

    @include setStyleByBreakpoint('padding', $padding);

    /deep/ .header-menu__container {
      flex-direction: column;
      justify-content: flex-start;
    }

    /deep/ .header-menu__item {
      height: 55px;
      margin-bottom: 25px;
      margin-right: 0;
    }

    /deep/ .header-menu__item-link {
      display: flex;
      height: 100%;
    }
  }
}
</style>
